<template>
    <v-dialog :value="show" width="600px" style="max-height: 100vh;" @click:outside="$emit('close')">
        <v-card class="justify-center">
            <v-toolbar
                color="primary"
                class="toolbar--wraped"
                dark
                flat
            >
                <v-toolbar-title>{{ video.title }}</v-toolbar-title>
                <v-spacer />
                <v-btn icon color="white" @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>

            <video controls autoplay style="width: 100%">
                <source :src="video.src" type="video/mp4">
                Sorry, your browser doesn't support embedded videos.
            </video>

            <v-col cols="12" class="mx-auto" v-if="video.steps">
                <div>
                    <h4 class="pl-1 mb-1">Steps</h4>
                    <ol class="scroller">
                        <template v-for="(step, j) in video.steps">
                            <li :key="j">{{ step }}</li>
                        </template>
                    </ol>
                </div>
            </v-col>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        video: Object,
        show: Boolean,
    }
}
</script>

<style scoped>
.scroller {
    max-height: 220px;
    overflow-y: scroll;
}
</style>
